import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { JiraExport } from 'DiscoveryEngine.TS/Export';
import { JiraExportConfigComponent } from '../jira-export-config/jira-export-config.component';

@Component({
	selector: 'sched-disc-config-jira',
	templateUrl: './sched-disc-config-jira.component.html',
	styleUrls: ['./sched-disc-config-jira.component.scss']
})
export class SchedDiscConfigJiraComponent extends SchedDiscConfigComponentBase {

	@ViewChild(JiraExportConfigComponent, { static: true })
	private JiraExportComp: JiraExportConfigComponent;

	private static NullJiraExport = new JiraExport();

	public get JiraExport(): JiraExport {
		if (this.Discovery)
			return this.Discovery.JiraExport;
		else
			return SchedDiscConfigJiraComponent.NullJiraExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.JiraExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.JiraExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.JiraExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.JiraExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.JiraExportComp.discardTempChanges();
	}

}
